
const accordionSection = () => ({
  init() {
    this.cacheNodes();
    this.initAccordion();
  },

  cacheNodes() {
    this.accordionQuestions = this.$root.querySelectorAll('.accordion--item__question');
  },

  initAccordion() {
    this.accordionQuestions.forEach((accordionQuestion) => {
      accordionQuestion.addEventListener('click', () => {
        let accordionArrow = accordionQuestion.querySelector('svg');
        accordionArrow.classList.toggle('rotate-180');

        let accordionItem = accordionQuestion.closest('.accordion--item');
        let accordionItemAnswer = accordionItem.querySelector('.accordion--item__answer');

        if (accordionArrow.classList.contains('rotate-180')) {
          var height = accordionItem.querySelector('.accordion--item__answer--content').offsetHeight;
          accordionItemAnswer.style.maxHeight = height + 'px';
        }
        else {
          accordionItemAnswer.style.maxHeight = '0px';
        }
      });
    });
  }
});

export default accordionSection;
